<template lang="html">
<div class="spark-line-wrapper">
    <div class="chart-title">
        <div class="caption"><b>{{ data.title }} ({{ data.units }})</b></div>
        <div>{{ dateRange }}</div>
    </div>
    <div class="chart-display">
        <!-- <div class="chart-value">
            <div>
                Median<br>
                <span>{{ this.median | numFormat }}</span>
            </div>
        </div> -->
        <!-- <div class="chart-value">
            <div>
                Mean<br>
                <span>{{ this.mean | numFormat }}</span>
            </div>
        </div> -->
        <spark-line :dot="true" :chartData="data.data" />
        <div class="chart-value">
            <div>
                Latest<br>
                <span>{{ this.latest.v | numFormat }}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as d3 from 'd3';
import SparkLine from '@/components/D3Sparkline';

export default {
    components: {
        SparkLine,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        first() {
            const { data } = this.data;
            return data[0];
        },
        latest() {
            const { data } = this.data;
            return data[data.length - 1];
        },
        mean() {
            const { data } = this.data;
            return d3.mean(data, d => d.v);
        },
        median() {
            const { data } = this.data;
            return d3.median(data, d => d.v);
        },
        dateRange() {
            const timeFormat = d3.timeFormat('%Y-%m-%d');
            const d0 = timeFormat(this.first.d);
            const d1 = timeFormat(this.latest.d);
            return `${d0} to ${d1}`;
        },
    },
    filters: {
        numFormat(value, format = '.1f') {
            if (!value) return '-';
            return d3.format(format)(value);
        },
    },
};
</script>

<style lang="scss">
.spark-line-wrapper {
    background: #fff;
    // border: 1px solid #ccc;
    color: #222;
    display: flex;
    flex-direction: column;
    font-size: .7rem;

    .chart-title {
        display: flex;
        padding: .25rem;
        justify-content: space-between;
    }
    .chart-display {
        display: flex;
        justify-content: space-between;

        svg.spark-line-chart {
            background: transparent;
            path.line {
                stroke: #1E88E5;
            }
            circle.value-dot {
                fill: #9CCC65;
            }
            circle.current-dot {
                fill: #1E88E5;
            }
        }

    }
    .chart-value {
        font-size: .75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        flex-shrink: 0;
        span {
            font-size: 1rem;
            font-weight: 700;
        }
    }
    .tooltip {
        background: rgba(#fff, 0.8);
        color: #222;
        border: 1px solid rgba(#222, 0.5);
        border-radius: 3px;
        font-size: 9px;
        min-width: auto;
        transition: top 200ms ease-out,
                    left 200ms ease-out;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/D3SparklineWrapper.vue